import React, { useState, useEffect } from "react";
import "./PaymentMethod.css";
import CommonBreadcrumb from "./../common_components/breadcrumb/CommonBreadcrumb";
import WhiteButton from "./../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { postOrder } from "../../features/admin/product/productdetails/Slice";
import { useRazorpay } from "react-razorpay";
import { getProduct } from "../../features/admin/product/productdetails/Slice";
import { AllAppSetup } from "../../features/admin/common/Slice";
import OrderSummary from "../cart/order_summary/OrderSummary";
import { Col } from "react-bootstrap";

const PaymentSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Razorpay } = useRazorpay();

  const [error, setError] = useState("");

  const productsdetails = useSelector((state) => state.product.productdetails);
  const all_app_setup = useSelector((state) => state?.common?.all_app_setup);
  const [qty, setQty] = useState(1);
  const [triggerSubmit, setTriggerSubmit] = useState(null);

  const orderData = JSON.parse(Cookies.get("orderData") || "{}");

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const breadcrumbItems = [
    { label: "Product", link: "/products" },
    { label: "Cart", link: "/cart" },
    { label: "Payment Method" },
  ];

  useEffect(() => {
    dispatch(getProduct());
    dispatch(AllAppSetup());
  }, [dispatch]);

  // =========================
  // OPEN RAZORPAY
  // =========================
  const openRazorpay = () => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_I05KCFb1v5JJRc",

      amount: Math.round(orderData?.grand_total * 100), // convert to paise
      currency: "INR",
      name: "Order Payment",
      description: "Product Purchase Payment",

      image: process.env.PUBLIC_URL + "/images/logo.png",

      handler: async function(response) {
        handleOrderCreate(response.razorpay_payment_id);
      },

      prefill: {
        name: orderData?.customer_name || "",
        email: orderData?.email || "",
        contact: orderData?.mobile || "",
      },

      theme: {
        color: "#f35f37",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  // =========================
  // AFTER PAYMENT SUCCESS
  // =========================
  // const handleOrderCreate = async (razorpayPaymentId) => {
  //   const sendData = {
  //     ...orderData,
  //     razorpay_id: razorpayPaymentId,
  //     amount: orderData?.grand_total,
  //   };

  //   try {
  //     const res = await dispatch(postOrder(sendData));
  //     const data = res?.payload;

  //     if (data?.success) {
  //       Cookies.remove("orderData");
  //       navigate("/order-placed");
  //     } else {
  //       // 👇 set error message instead of alert
  //       setError(data?.message || "Order creation failed after payment.");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setError("Something went wrong. Please try again.");
  //   }
  // };

  const handleOrderCreate = async (razorpayPaymentId) => {
    const sendData = {
      ...orderData,
      razorpay_id: razorpayPaymentId,
      amount: orderData?.grand_total,
    };

    try {
      const res = await dispatch(postOrder(sendData));

      // ✅ success case
      if (postOrder.fulfilled.match(res)) {
        Cookies.remove("orderData");
        navigate("/order-placed");
      }

      // ❌ error case (this is what you need)
      if (postOrder.rejected.match(res)) {
        setError(res?.payload?.message || "Order failed");
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <section className="payment-section">
      <CommonBreadcrumb items={breadcrumbItems} />

      <div className="container payment-container-wapper px-md-5 px-sm-5">
        {/* <div className="payment-container">
          <div className="payment-product-card">
            <div className="product-img">
              <img src="/images/cart/productImg.png" alt="product" />
            </div>

            <div className="product-details">
              <h4>{orderData?.product_name}</h4>
              <p>{htmlToReactParser.parse(orderData?.description)}</p>

              <span>
                {orderData?.power} - {orderData?.capsule_quantity} Capsules
              </span>
            </div>
          </div>

          <div className="payment-total">
            <p className="grand-total">Grand Total</p>
            <p className="price">₹ {orderData?.grand_total}</p>
          </div>

          {error && <p className="payment-error">{error}</p>}

          <div className="payment-btn">
            <WhiteButton
              className="w-btn"
              title={"Complete Payment"}
              bg="#000"
              color="#f35f37"
              hoverColor="#f35f37"
              hoverBg={"#000"}
              onClick={openRazorpay}
            />
          </div>
        </div> */}

        <div className="payment-container">
          <OrderSummary
            productsdetails={productsdetails}
            all_app_setup={all_app_setup}
            qty={orderData?.quantity}
            hideButton={true}
          />

          {error && <p className="payment-error">{error}</p>}

          <div className="payment-btn">
            <WhiteButton
              className="w-btn"
              title={"Complete Payment"}
              bg="#000"
              color="#f35f37"
              hoverColor="#f35f37"
              hoverBg={"#000"}
              onClick={openRazorpay}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentSection;
